export default __webpack_public_path__ + "static/header.wko-f2567512e317dcd46d1e6e2a947ce7ce.png";